module.exports = __webpack_public_path__ + "img/cover-redeem-bg.16259aa4.png";